<template>
  <div class="row">
    <div class="col-12">
      <form role="form">
        <div class="form-group row" v-if="category.sub == 0">
          <div class="col-md-3">
            <img
              style="max-width: 100%; margin: 0 auto"
              :src="category.img_url ? category.img_url : defaultImgUrl"
            />
          </div>

          <div class="col-md-8">
            <label class="col-form-label"> {{ $t("image") }}: </label>
            <input-file
                ref="inputNailImg"
                :inputData.sync="category.img_url"
                :prefix="`https://vnfr.cosmogroup.pl/assets`"
                :label="$t('nail_image')"
                :urlUploadFile="urlUpdateFile()"
                name="product_nail_image_url"
                @loading="updateFileLoading"
            ></input-file>
            <!-- <input
              name="category_img"
              type="text"
              class="form-control"
              v-model="category.img_url"
              v-validate="'required'"
            /> -->
            <small v-show="errors.has('category_img')" class="text-danger">
              {{ $t("field_required") }}
            </small>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-3">
            <label class="col-form-label">{{ $t("parent_category") }}:</label>
          </div>
          <div class="col-md-8">
            <select
              name="category_sub"
              style="width: 100%"
              class="form-control"
              v-model="category.sub"
            >
              <option
                v-for="(type, i) in categoriesList"
                :value="type.id"
                :key="i"
              >
                {{ type.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-3">
            <label class="col-form-label">{{ $t("sort") }}:</label>
          </div>
          <div class="col-md-8">
            <input
              type="text"
              name="sort"
              class="form-control"
              v-model="category.sort"
              v-validate="'required'"
            />
            <small
              v-show="errors.has('sort')"
              class="text-danger"
            >
              {{ $t("field_required") }}
            </small>
          </div>
        </div>
        <div class="mb-4 text-md">{{ $t("names_different_langs") }}:</div>
        <div
          v-for="(l, i) in langsFormData"
          :key="i"
          class="form-group row"
        >
          <label class="pl-4 col-sm-3 col-form-label">{{
            l.lang.toUpperCase()
          }}</label>
          <div class="col-md-8">
            <input
              type="text"
              :name="'langValue-' + l.lang"
              class="form-control"
              v-model="l.name"
              v-validate="'required'"
            />
            <small
              v-show="errors.has('langValue-' + l.lang)"
              class="text-danger"
            >
              {{ $t("field_required") }}
            </small>
          </div>
        </div>
        <div class="hr-line-dashed"></div>
      </form>
    </div>
    <div class="col-12">
      <div
        v-if="editModel && this.roles.id === 1"
        class="btn mx-sm-2 mx-md-0 my-2 btn-danger d-block d-md-inline-block"
        @click.prevent="deleteCategory()"
      >
        {{ $t("remove_category") }}
      </div>
      <div
        type="submit"
        class="
          btn
          mx-md-2
          my-2
          btn-primary
          d-block d-md-inline-block
          float-md-right
        "
        v-text="
          editModel ? this.$t('update_category') : this.$t('save_category')
        "
        @click.prevent="saveCategory()"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import InputFile from '@/components/InputFile'

export default {
  name: 'CategoryForm',
  data() {
    return {
      category: {
        img_url: '',
        sub: 0,
        sort: null,
        lang: []
      },
      editModel: false,
      defaultImgUrl: 'https://cdn2.neonail.pl/all/default-placeholder.png',
      categoriesList: [],
      defaultLangs: [ 'pl', 'en', 'de', 'es', 'fr', 'it' ],
      langsFormData: []
    }
  },
  components: {
    InputFile
  },
  computed: {
    ...mapGetters( 'users', [ 'roles' ] )
  },
  async created() {
    this.$emit( 'loading', true )
    if ( this.$route.params.id !== undefined ) {
      await this.getData()
      this.editModel = true
    }
    await this.getCategoriesList()
    this.createdLangsFormData()
    this.$emit( 'loading', false )
  },
  methods: {
    urlUpdateFile() {
      return `vnfr/${this.$route.params.env}/categories/file`
    },
    updateFileLoading( loading ) {
      this.$emit( 'loading', loading )
    },
    getData() {
      return this.$http
        .get(
          `vnfr/${this.$route.params.env}/categories/${this.$route.params.id}`
        )
        .then( resp => {
          this.category = resp.data.category
          return true
        } )
        .catch( err => {
          this.$toastr.error( err )
          return false
        } )
    },
    getCategoriesList() {
      return this.$http
        .get( `vnfr/${this.$route.params.env}/categories/select-list` )
        .then( resp => {
          const categories = resp.data.data
          if ( this.$route.params.id !== undefined ) {
            console.log( 'filter category', categories )
            this.categoriesList = categories.filter( element => element.id != this.$route.params.id )
            console.log( 'categoriesList', this.categoriesList, categories )
          } else {
            this.categoriesList = categories
          }
          return true
        } )
        .catch( err => {
          this.$toastr.error( err )
          return false
        } )
    },
    createdLangsFormData() {
      this.defaultLangs.forEach( lang => {
        const elementIndex = this.category.lang.findIndex( element => element.lang == lang )
        if ( elementIndex !== -1 ) {
          this.langsFormData.push( this.category.lang[ elementIndex ] )
        } else {
          this.langsFormData.push( this.defaultLangsData( lang ) )
        }
      } )
    },
    defaultLangsData( lang ) {
      return {
        id: null,
        name: '',
        lang: lang
      }
    },
    deleteCategory() {
      this.$emit( 'loading', true )
      this.$http
        .delete(
          `vnfr/${this.$route.params.env}/categories/${this.$route.params.id}`
        )
        .then( resp => {
          this.$toastr.success( 'Usunięte!!' )
          this.$emit( 'loading', false )
          this.$router.push(
            `/przymierzalnia/${this.$route.params.env}/kategorie`
          )
        } )
        .catch( err => {
          this.$toastr.error( err )
          this.$emit( 'loading', false )
        } )
    },
    saveCategory() {
      this.$validator.validateAll().then( result => {
        if ( result ) {
          this.$emit( 'loading', true )
          const url = `vnfr/${this.$route.params.env}/categories`
          this.category.lang = this.langsFormData
          this.$http( {
            url:
              this.$route.params.id !== undefined
                ? `${url  }/${this.$route.params.id}`
                : url,
            method: this.$route.params.id !== undefined ? 'put' : 'post',
            data: this.category
          } )
            .then( resp => {
              this.$toastr.success( 'Zapisane!!' )
              this.$emit( 'loading', false )
              this.$router.push(
                `/przymierzalnia/${this.$route.params.env}/kategorie`
              )
            } )
            .catch( err => {
              this.$toastr.error( err )
              this.$emit( 'loading', false )
            } )
        }
      } )
    }
  }
}
</script>

<style scoped>
a {
  color: white;
}
.custom-border-px {
  margin: 0 15px;
}
</style>
